<template>
  <section class="tags-news-list">
    <section
      class="tag-filter"
      v-if="isShowTagsFilter"
    >
      <ul class="tag-wrap">
        <li :class=" typeValue == ''?'active':''">
          <a href="/news">
            {{ $t('news-list.all') }}
          </a>
        </li>
        <li
          v-for="(tag,index) in NewsLabel"
          :class="tag.id === typeValue?'active':''"
          :key="index"
        >
          <a :href="'/news?type='+ allTypes[tag.id]">
            {{tag.typeName}}
          </a>
        </li>
      </ul>
    </section>
    <section v-if="nordata">
      <section
        v-for="(item,index) in nordata"
        :key="index"
        class="article-content"
      >
        <a
          class="detail-left"
          :href="$i18n.path(`news/${item.id}`)"
          target="_blank"
        >
          <img
            :src="'https://cdn.gelonghui.com/static/web/newsType_'+item.type+'.png'"
            :alt="item.title"
          >
        </a>
        <section class="detail-right">
          <a
            :href="$i18n.path(`news/${item.id}`)"
            target="_blank"
          >
            <h2>{{ item.title }}</h2>
            <summary>{{ item.content }}</summary>
          </a>

          <section class="time-stock">
            <a
              :class="['stock',tags.netChange > 0?'positive': tags.netChange == 0 ? 'zero':'negative']"
              v-for="(tags,index) in item.stocks"
              :key="index"
              :href="$i18n.path(`stock/${tags.stockCode}`)"
              v-if="index < 2"
            >
              <span class="iconfont">{{tags.netChange >= 0?"&#xe608;":"&#xe609;"}}</span>
              <span>{{tags.stockName}}</span>
              <span>{{tags.netChange > 0 ? '+'+(tags.netChange*100).toFixed(2)+'%' : tags.netChange == 0 ? '0.00%' :
                (tags.netChange*100).toFixed(2)+'%'}}</span>
            </a>
            <div style="flex-grow: 1;"></div>
            <p class="time">
              <span>{{item.typeName}}</span>
              <span>|</span>
              <span>{{ item.createDate | formatTime}}</span>
            </p>
          </section>
        </section>
      </section>
    </section>

    <p
      id="waterfall"
      v-if="!page && nordata && nordata.length > 0"
    >
      <span @click="getMoreNews()">加载更多</span>
    </p>
    <!-- <p id="waterfall"  v-else="page"><a :href="'/news/page/'+ (page+1)">下一页</a></p> -->
    <pagination
      v-else
      :totalCount="totalCount"
    ></pagination>
  </section>
</template>
<script>
import allStates from "~/plugins/allStates";
import {
  parseTime
} from "~/plugins/filters";
import pagination from "~/components/public/pagination";
export default {
  name: "details-news",
  props: ["nordata", "NewsLabel", "stockCodeList", "totalCount", "newsType", "typeValue"],
  data() {
    return {
      page: null,
      isShowTagsFilter: true,
      allTypes: {
        27: 'announcement',
        28: 'linerating',
        30: 'performance',
        32: 'hkstockchange',
        33: 'companyInfo',
        36: 'marketmacro',
        37: 'newstock'
      }
    };
  },
  filters: {},
  created() {
    this.newsStates = allStates.newsStates;
  },
  methods: {
    getMoreNews() {
      this.$emit("getMoreNews", this.typeValue);
    }
  },
  watch: {},
  components: {
    pagination
  },
  created() {
    this.page = Number(this.$route.params.id);
    if (this.$route.name == "news-page-id") {
      this.isShowTagsFilter = false;
    }
  }
};

</script>
<style lang="less" scoped>
.tags-news-list {
  width: 852px;
  padding: 10px 30px 22px 22px;
  background-color: #fff;
  margin: 0 0 80px 0;

  .tag-filter {
    width: 100%;

    .tag-wrap {
      width: 100%;
      background-color: #fff;
      display: flex;
      height: 60px;
      border-bottom: 1px solid rgb(230, 230, 230);
      box-sizing: border-box;

      > li {
        position: relative;
        padding: 6px 10px;
        width: 14.285%;
        text-align: center;
        height: 60px;
        line-height: 48px;
        vertical-align: middle;
        cursor: pointer;
        font-size: 16px;
        font-weight: 400;
        a {
          color: #323232;
        }

        &:hover {
          font-size: 1.2em;
          // line-height: 1.2em;
          font-weight: bolder;
          padding: 6px 5px;
        }
      }

      > .active {
        font-size: 1.2em;
        font-weight: bolder;
        padding: 6px 5px;
        border-bottom: 2px solid #88a8de;
        a {
        }
      }
    }
  }

  .article-content {
    height: 146px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    margin: 20px 0 20px 0;
    border-bottom: 0.5px solid #dfdfdf;

    .detail-left {
      width: 180px;
      height: 125px;
      cursor: pointer;
      display: block;
      overflow: hidden;
      border-radius: 5px;

      img {
        width: 100%;
        height: 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.4s ease;
      }

      &:hover img {
        width: 105%;
        height: 105%;
      }
    }

    .detail-right {
      width: 596px;
      position: relative;

      a {
        h2 {
          margin-bottom: 5px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-height: 1.4;
          font-weight: 600;
          font-size: 18px;
          color: #333;
          cursor: pointer;

          &:hover {
            color: #3278d2;
          }
        }

        summary {
          height: 40px;
          font-size: 14px;
          line-height: 20px;
          overflow: hidden;
          color: #666;
          cursor: pointer;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          &:hover {
            color: #000;
          }
        }
      }

      .time-stock {
        width: 100%;
        height: 26px;
        font-size: 12px;
        line-height: 26px;
        left: 0;
        bottom: 0;
        position: absolute;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .time {
          font-size: 12px;
          color: rgba(131, 141, 151, 1);

          > span::nth-child(2) {
            margin: 0 8px;
          }
        }

        .stock {
          margin-right: 16px;
          font-size: 12px;
          font-weight: 400;
          padding: 0 14px;
          height: 26px;
          border-radius: 4px;
          line-height: 26px;
          display: flex;
          align-items: center;

          span:nth-child(2) {
            margin: 0 8px 0 8px;
          }
        }

        .positive {
          color: rgba(255, 90, 90, 1);
          background: rgba(250, 237, 237, 1);
        }

        .zero {
          color: rgb(97, 96, 96);
          background: #e8e8e8e8;
        }

        .negative {
          color: rgba(5, 195, 91, 1);
          background: rgba(237, 250, 242, 1);
        }
      }
    }
  }
}
</style>
